import React, { useContext, useEffect, useMemo, useState } from 'react';
import { CrLoadingOverlay } from '../cr/CrLoadingOverlay';
import styles from '../../styles/cr.module.scss';
import axios from 'axios';
import { DataContext } from '../DataContext';
import { ICAPeriod, ResponsesA, UserAppLaunchLog } from '../../types';
import { AppGlobals, AppIDs } from '../../AppGlobals';
import { PrimaryButton } from '@fluentui/react';
import { useHistory } from 'react-router-dom';
import { AppWelcomeButtons } from '../AppWelcomeButtons';
import {
    color1,
    color1Label,
    color2,
    color2Label,
    color3,
    color3Label,
    color4,
    color4Label,
    color5,
    color5Label,
    barDefaultBackgroundColor
} from './RagRatingBarColors';
import { RagRatingBar } from '../cr/RagRatingBar';
import { OrbUserContext } from '../OrbUserContext';

interface CaWelcomeProps {
}

export interface IAppWelcomeText {
    CenteralHeading: string;
    CenteralBody: string;
    CustomerWelcomeHeading: string;
    CustomerWelcomeBody: string;
}

export const CaWelcome: React.FC<CaWelcomeProps> = ({ }) => {
    const { dataServices } = useContext(DataContext);
    const { orbConfig } = useContext(OrbUserContext);
    const history = useHistory();
    const [formData, setFormData] = useState<IAppWelcomeText>(null);
    const [controlSummary, setControlSummary] = useState({
        CurrentPeriodTitle: '',
        TotalControlQuestions: 0,
        Controls_SubstantialPercentage: 0,
        Controls_UnsatisfactoryPercentage: 0,
        Controls_ModeratePercentage: 0,
        Controls_LimitedPercentage: 0,
        Controls_NAPercentage: 0
    });

    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);

                // Your existing API calls
                const zedxNetapiURL = process.env.REACT_APP_ZedX_Net_API!;
                const zedxNetWelcomeTextApi: string = `${zedxNetapiURL}/availableapps/GetAppWelcomeText/CA/${AppGlobals.CustomerRef}`;
                const centeralWelcomeText = (await axios.get(zedxNetWelcomeTextApi)).data;
                const centeralWelcomeHeading = centeralWelcomeText.WelcomeHeading;
                const centeralWelcomeBody = centeralWelcomeText.WelcomeBody;

                let customerWelcomeHeading: string = '';
                let customerWelcomeBody: string = '';

                const clDefForm = await dataServices.caDefFormService.readAll();
                if (clDefForm.length > 0) {
                    customerWelcomeHeading = clDefForm[0].Title ?? '';
                    customerWelcomeBody = clDefForm[0].Details ?? '';
                }

                setFormData({
                    CenteralHeading: centeralWelcomeHeading,
                    CenteralBody: centeralWelcomeBody,
                    CustomerWelcomeHeading: customerWelcomeHeading,
                    CustomerWelcomeBody: customerWelcomeBody
                });

                dataServices.userAppLaunchLogService.create(new UserAppLaunchLog(AppIDs.CA));

                dataServices.caPeriodService.readAll().then(async (pArr: ICAPeriod[]) => {
                    let currentPeriodId: number = 0;
                    const currentPeriod = pArr.filter(p => p.PeriodStatus === "Current Period");
                    if (currentPeriod && currentPeriod.length > 0) {
                        currentPeriodId = currentPeriod[0].ID;
                        console.log(currentPeriod);
                        console.log('currentPeriodId', currentPeriodId);

                        // Get the count safely
                        const orgLevel3Entities = await dataServices.orgLevel3Service.countAllOpenEntities();
                        const totalOrgLevel3s = Array.isArray(orgLevel3Entities) ? orgLevel3Entities.length : 0;

                        //load data for bar chart
                        const dfArr = await dataServices.caDefElementService.readAllDefElementsForPeriod(currentPeriodId);

                        //console.log('dfArr', dfArr);

                        let totalQuestionsSectionAForAllL3 = 0;
                        let totalQuestionsSectionA = 0;
                        let totalSubstantial = 0;
                        let totalUnsatisfactory = 0;
                        let totalModerate = 0;
                        let totalLimited = 0;
                        let totalNA = 0;

                        dfArr.forEach((df) => {
                            for (let i = 1; i <= 10; i++) {
                                const question = (df as any)[`SectionAQuestion${i}`];
                                if (question) {
                                    totalQuestionsSectionA++;

                                    df['CAElements']?.forEach((fd) => {
                                        const response = (fd as any)[`ResponseA${i}`];

                                        if (response === ResponsesA.Substantial) totalSubstantial++;
                                        else if (response === ResponsesA.Unsatisfactory) totalUnsatisfactory++;
                                        else if (response === ResponsesA.Moderate) totalModerate++;
                                        else if (response === ResponsesA.Limited) totalLimited++;
                                        else if (response === ResponsesA.NA) totalNA++;
                                    });
                                }
                            }
                        });

                        // Ensure totalQuestionsSectionA is a valid number
                        const safeTotalQuestionsSectionA = Number.isFinite(totalQuestionsSectionA) ? totalQuestionsSectionA : 0;

                        // Final calculation
                        totalQuestionsSectionAForAllL3 = safeTotalQuestionsSectionA * totalOrgLevel3s;

                        // console.log('totalQuestionsSectionA', totalQuestionsSectionA);
                        // console.log('totalOrgLevel3s', totalOrgLevel3s);
                        // console.log('totalQuestionsSectionAForAllL3', totalQuestionsSectionAForAllL3);
                        // console.log('totalSubstantial', totalSubstantial);
                        // console.log('totalUnsatisfactory', totalUnsatisfactory);
                        // console.log('totalModerate', totalModerate);
                        // console.log('totalLimited', totalLimited);
                        // console.log('totalNA', totalNA);

                        const safeDivide = (count: number) =>
                            totalQuestionsSectionAForAllL3 > 0 ? Math.round((count / totalQuestionsSectionAForAllL3) * 100) : 0;

                        const substantialPercentage = safeDivide(totalSubstantial);
                        const unsatisfactoryPercentage = safeDivide(totalUnsatisfactory);
                        const moderatePercentage = safeDivide(totalModerate);
                        const limitedPercentage = safeDivide(totalLimited);
                        const naPercentage = safeDivide(totalNA);

                        // Set these to your state as needed
                        setControlSummary({
                            CurrentPeriodTitle: currentPeriod[0]?.Title,
                            TotalControlQuestions: totalQuestionsSectionAForAllL3,
                            Controls_SubstantialPercentage: substantialPercentage,
                            Controls_UnsatisfactoryPercentage: unsatisfactoryPercentage,
                            Controls_ModeratePercentage: moderatePercentage,
                            Controls_LimitedPercentage: limitedPercentage,
                            Controls_NAPercentage: naPercentage
                        });
                    }

                }, (err) => { });



                setLoading(false);
            } catch (error) {
                console.error('Error loading entity:', error);
                setLoading(false);
            }
        };

        fetchData();
    }, []);


    const formattedCenteralBody = useMemo(() => {
        if (!formData) return '';

        return formData.CenteralBody ? formData.CenteralBody.replace(/\n/g, '<br>') : '';
    }, [formData]);

    const formattedCustomerBody = useMemo(() => {
        if (!formData) return '';

        return formData.CustomerWelcomeBody ? formData.CustomerWelcomeBody.replace(/\n/g, '<br>') : '';
    }, [formData]);

    const handleUpdatesClick = () => {
        history.push('/a9/updates');
    };

    const handleInsightsClick = () => {
        history.push('/a9/insights');
    };

    return (

        <div style={{ maxWidth: '1200px' }} className={styles.cr}>
            <CrLoadingOverlay isLoading={loading} opaque={true} />
            {formData && (
                <>
                    <h1 style={{ textAlign: 'center', marginLeft: '20px' }} className={styles.welcomeL1Heading}>{formData.CenteralHeading}</h1>
                    <div className="welcomePage-container">
                        <div className="welcomePage-leftDiv">
                            <div>
                                <div className={styles.welcomeBody} dangerouslySetInnerHTML={{ __html: formattedCenteralBody }} />
                            </div>
                            <div>
                                {formData.CustomerWelcomeHeading?.length > 0 && <div style={{ fontWeight: 'bold', textDecoration: 'underline' }} className={styles.welcomeBody}>{formData.CustomerWelcomeHeading}</div>}
                            </div>
                            <div>
                                {formattedCustomerBody?.length > 0 && <div className={styles.welcomeBody} dangerouslySetInnerHTML={{ __html: formattedCustomerBody }} />}
                            </div>
                            <br />
                            <AppWelcomeButtons
                                onUpdatesClick={handleUpdatesClick}
                                onInsightsClick={handleInsightsClick}
                            />
                        </div>
                        <div className="welcomePage-rightDiv">

                            <React.Fragment>
                                <div style={{ marginTop: '10px', marginBottom: '15px', borderStyle: 'solid', borderWidth: '1px', borderColor: 'rgb(230,230,230)', backgroundColor: 'rgb(245,245,245)', padding: '20px 10px' }}>
                                    <div style={{ marginBottom: '10px', fontWeight: 600 }}>
                                        Your overall ratings for the Controls across the {orbConfig.OrgTypeLabel} for the current period ({controlSummary.CurrentPeriodTitle})  are as follows.
                                    </div>
                                    <RagRatingBar
                                        barWidth='100%'
                                        barHeight='35px'
                                        barDefaultBackgroundColor={barDefaultBackgroundColor}
                                        noDataLabel='Not Completed'
                                        color1={color1}
                                        color1Percentage={controlSummary.Controls_SubstantialPercentage}
                                        color1Label={color1Label}
                                        color2={color2}
                                        color2Percentage={controlSummary.Controls_ModeratePercentage}
                                        color2Label={color2Label}
                                        color3={color3}
                                        color3Percentage={controlSummary.Controls_LimitedPercentage}
                                        color3Label={color3Label}
                                        color4={color4}
                                        color4Percentage={controlSummary.Controls_UnsatisfactoryPercentage}
                                        color4Label={color4Label}
                                        color5={color5}
                                        color5Percentage={controlSummary.Controls_NAPercentage}
                                        color5Label={color5Label}
                                        showInfoSection={true}
                                        displayPercentageBarView={false}
                                    />
                                </div>
                            </React.Fragment>
                        </div>
                    </div>
                </>
            )}
        </div>

    );
};